import { BorerShiftCrewDocument } from '../BorerShiftCrew/queryBuilder';
import { BorerShiftCrewMemberRoleDocument } from '../BorerShiftCrewMemberRole/queryBuilder';
import { SIGNATURE_BATCH_SIZE } from '../BorerShiftSignature/queryBuilder';
import { EmployeeDocument } from '../Employees/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  BorerShiftCrewMemberDocument,
  borerShiftCrewMemberPullQueryBuilder,
  borerShiftCrewMemberPushModifier,
  borerShiftCrewMemberPushQueryBuilder,
} from './queryBuilder';

export function borerShiftCrewMemberFamilyMember(
  configBuilder: ConfigBuilder,
  borerShiftCrew: FamilyMember<BorerShiftCrewDocument>,
  borerShiftCrewMemberRole: FamilyMember<BorerShiftCrewMemberRoleDocument>,
  employees: FamilyMember<EmployeeDocument>,
): FamilyMember<BorerShiftCrewMemberDocument> {
  const syncConfig = configBuilder<BorerShiftCrewMemberDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_CREW_MEMBER,
  );
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, borerShiftCrewMemberPullQueryBuilder);
  pullConfig.batchSize = SIGNATURE_BATCH_SIZE;

  const pushConfig = push(syncConfig, borerShiftCrewMemberPushQueryBuilder);
  pushConfig.modifier = borerShiftCrewMemberPushModifier;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_CREW_MEMBER, replicationState, [
    borerShiftCrew,
    borerShiftCrewMemberRole,
    employees,
  ]);
}
